package horcrux.common.extensions

import arrow.core.NonEmptyList
import horcrux.common.types.NonEmptyMap
import horcrux.common.utils.getOrThrow

inline fun <A, B : Comparable<B>> NonEmptyList<A>.nonEmptySortedBy(crossinline selector: (A) -> B?): NonEmptyList<A> =
    this.sortedBy(selector).toNonEmptyList().getOrThrow()

val <A : Comparable<A>, B> NonEmptyMap<A, B>.head: Pair<A, B>
    get() = this.toNonEmptyList().nonEmptySortedBy { it.first }.head

fun <A : Comparable<A>, B> NonEmptyMap<A, B>.last(): Pair<A, B> =
    this.toNonEmptyList().nonEmptySortedBy { it.first }.last()

fun <A : Comparable<A>, B> NonEmptyMap<A, B>.replaceLast(value: B): NonEmptyMap<A, B> =
    this.last().first.let { lastKey -> this.replace(lastKey, value) }

inline fun <A, B, C : Comparable<C>> NonEmptyMap<A, B>.nonEmptySortedBy(
    crossinline selector: (Pair<A, B>) -> C
): NonEmptyList<Pair<A, B>> = this.toList().sortedBy { selector(it) }.toNonEmptyList().getOrThrow()
